<template>
  <VDialog
    :open="isOpen"
    modal
    @close="handleCancel"
    class="customer-delete-dialog"
    style="--dialog-min-inline-size: 400px; --dialog-max-inline-size: 400px;"
  >
    <template #body>
      <div class="deleteModalContent">
        <div class="exportImgContainer vmb-20">
          <VIcon name="delete-line" :size="-5" class="customer_delete" style="color: white"></VIcon>
          <p class="headerTitle">Are you sure ?</p>
        </div>
        <div>
          <p class="vtext-subtitle vpb-10">
            Enter "DELETE" to confirm <span class="trashIcon">*</span>
          </p>
          <VTextField
            v-model="confirmationText"
            placeholder="Enter DELETE"
            aria-label="Enter DELETE"
            :maxlength="6"
            appearance="ghost"
            class="vivid-input"
            @keyup.enter="handleConfirm"
          ></VTextField>
        </div>
      </div>
    </template>
    <template #action-items>
      <div class="footerBttn">
        <VButton
          class="vvd-btn-primary flex100P"
          connotation="cta"
          appearance="filled"
          label="Yes"
          :disabled="confirmationText !== 'DELETE'"
          @click="handleConfirm"
        ></VButton>
        <VButton
          class="vvd-btn-cancel flex100P"
          appearance="filled"
          label="No"
          @click="handleCancel"
        ></VButton>
      </div>
    </template>
  </VDialog>
</template>

<script>
export default {
  name: 'CustomerDeleteModal',
  props: {
    isOpen: { type: Boolean, required: true },
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {
      confirmationText: '',
    };
  },
  watch: {
    isOpen(val) {
      if (!val) {
        this.confirmationText = '';
      }
    },
  },
  methods: {
    handleConfirm() {
      if (this.confirmationText === 'DELETE') {
        this.$emit('confirm');
        this.confirmationText = '';
      }
    },
    handleCancel() {
      this.confirmationText = '';
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.headerTitle {
  font-size: 24px;
  font-weight: 700;
  color: var(--black);
  line-height: 36px;
  margin: 0;
}
.exportImgContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
}
.customer_delete {
  background: var(--orange);
  border-radius: 5px;
  padding: 5px;
}
.footerBttn {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
}
.deleteModalContent {
  padding: 10px 0;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
</style>
